'use client';

import { c as _c } from "react/compiler-runtime";
import { ToastProvider as CommonToastProvider } from '@common/components';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { findRoute } from '@/utils';
import { DONATION_BNB_TOAST_ITEMS } from '../donation/constants';
interface ToastProviderProps {
  children: ReactNode;
}
export const ToastProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const isTopToast = findRoute(pathname)?.toastDirection === "top";
  const isDonationBnbRoute = DONATION_BNB_TOAST_ITEMS.some(t1 => {
    const {
      route
    } = t1;
    return route.pathname === pathname;
  });
  const positionClassName = isTopToast ? "!top-16" : isDonationBnbRoute ? "!bottom-[calc(var(--toast-bottom-offset,60px)+16px+var(--safe-area-bottom,0px))]" : "!bottom-[calc(var(--toast-bottom-offset,0px)+16px+var(--safe-area-bottom,0px))]";
  const t2 = isTopToast ? "top-center" : "bottom-center";
  let t3;
  if ($[0] !== positionClassName || $[1] !== t2) {
    t3 = <CommonToastProvider className={positionClassName} position={t2} />;
    $[0] = positionClassName;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t3) {
    t4 = <>{children}{t3}</>;
    $[3] = children;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};